<template>
    <div class="login">
        <BgManageTopbar />
        <div class="loginContent">
            <div class="logoDiv">
                <img src="@/assets/logo.png" @click="goHomeUrl()" alt="" class="logoImg">
            </div>
            <div class="loginFormDiv">
                <div class="loginForm">
                    <div class="loginFormContent">
                        <div class="loginFormTitle">登录</div>
                        <div class="tabsDiv">
                            <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true">
                                <el-tab-pane label="成果申报" name="first"></el-tab-pane>
                                <el-tab-pane label="推荐单位" name="second"></el-tab-pane>
                                <el-tab-pane label="推荐个人" name="third"></el-tab-pane>
                                <el-tab-pane label="专家评委" name="fourth"></el-tab-pane>
                            </el-tabs>
                            <el-form label-position="top" label-width="80px" :model="formLabelAlign"
                                :rules="rules" ref="loginForm" class="loginFormByTab">
                                    <!-- 推荐单位：显示selectTab -->
                                    <div class="selectTab" v-if="activeName == 'second'">
                                    <div class="flexAliCenter pl10" :class="tjdwSelectIndex==0 ? 'active' : 'notActive'" @click="tjdwSelectIndex=0">
                                        <div class="flexAliCenter">
                                            <img :src="tjdwSelectIndex==0 ? tjdwImgActive : tjdwImg" class="tjdwImg" alt="">
                                        </div>
                                        <div>推荐单位名称登录</div>
                                    </div>
                                    <div class="flexAliCenter pl10" :class="tjdwSelectIndex==1 ? 'active' : 'notActive'" @click="tjdwSelectIndex=1">
                                        <div class="flexAliCenter">
                                            <img :src="tjdwSelectIndex==1 ? userImgActive : userImg" class="tjdwImg" alt="">
                                        </div>
                                        <div>推荐单位管理手机号</div>
                                    </div>
                                    </div>
                                    <!-- 成果申报/专家评委：显示手机号 -->
                                    <el-form-item :label="(activeName == 'first' || (activeName == 'second' && tjdwSelectIndex == 1))?'手机号':activeName == 'fourth' ? '账号' : ''" prop="mobile" v-if="activeName == 'first' || activeName == 'fourth' || (activeName == 'second' && tjdwSelectIndex == 1)">
                                        <el-input v-model="formLabelAlign.mobile" :placeholder="(activeName == 'first' || (activeName == 'second' && tjdwSelectIndex == 1))?'请输入手机号':activeName == 'fourth' ? '请输入账号' : ''"></el-input>
                                    </el-form-item>
                                    <!-- 推荐单位：显示推荐单位 -->
                                    <el-form-item label="推荐单位" prop="tjdw_id" v-if="activeName == 'second' && tjdwSelectIndex == 0">
                                        <el-select filterable clearable v-model="formLabelAlign.tjdw_id" placeholder="请选择推荐单位" style="width: 100%;">
                                        <el-option :label="recommend.user_name" :value="recommend.id" v-for="recommend in recommendList"></el-option>
                                        
                                        </el-select>
                                    </el-form-item>
                                    <!-- 推荐个人：显示推荐个人 -->
                                    <el-form-item label="推荐个人" prop="tjgr_id" v-if="activeName == 'third'">
                                        <el-select filterable clearable v-model="formLabelAlign.tjgr_id" placeholder="请选择推荐个人" style="width: 100%;">
                                            <el-option :label="recommend.user_name" :value="recommend.id" v-for="recommend in IndividualList"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <!-- 登录密码：始终显示 -->
                                    <el-form-item label="登录密码" prop="password">
                                        <div class="pwdDiv">
                                            <el-input :type="pwdType" v-model="formLabelAlign.password"
                                                placeholder="请输入登录密码"></el-input>
                                            <img :src="pwdType == 'password' ? noPwdIcon : pwdIcon"
                                                class="pwdImg" alt="" @click="togglePwdType">
                                        </div>
                                    </el-form-item>
                                    <!-- 记住密码：只在first时显示 -->
                                    <el-form-item v-if="activeName == 'first'">
                                        <div class="pwdOptions">
                                            <el-checkbox v-model="rememberPwd">记住密码</el-checkbox>
                                            <span class="forgetPwd" @click="forgetPwd">忘记密码?</span>
                                        </div>
                                    </el-form-item>
                                    <!-- 登录按钮 -->
                                    <el-form-item>
                                        <el-button :loading="loading" :style="{marginTop: activeName=='first' ? '0' : '20px'}" type="primary" @click="onSubmit" class="loginBtn">登录</el-button>
                                        <el-button @click="goRegister" class="registerBtn" v-if="activeName == 'first'">注册</el-button>
                                    </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
            <CommonFooter />
        </div>
    </div>
</template>

<script>
import BgManageTopbar from '../components/BgManageTopbar.vue'
import CommonFooter from '../components/CommonFooter.vue'
import noPwdIcon from '@/assets/noPwd.png'
import pwdIcon from '@/assets/pwd.png'
import tjdwImg from '@/assets/tjdwImg.png'
import userImg from '@/assets/userImg.png'
import tjdwImgActive from '@/assets/tjdwImgActive.png'
import userImgActive from '@/assets/userImgActive.png'
import { mapState } from 'vuex'
export default {
    name: 'Login',
    components: {
        BgManageTopbar,
        CommonFooter
    },
    data() {
        return {
            loading: false,
            recommendList:[],
            IndividualList:[],
            pwdType: 'password',
            activeName: 'first',
            tjdwSelectIndex:0,
            rememberPwd: false,
            formLabelAlign: {
                mobile: '',
                password: '',
                type: '',
                tjdw_id: '',
                tjgr_id: ''
            },
            noPwdIcon,
            pwdIcon,
            tjdwImg,
            userImg,
            tjdwImgActive,
            userImgActive,
            rules: {
                mobile: [
                    { required: true, message: '请输入内容', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '请输入登录密码', trigger: 'blur' }
                ],
                tjdw_id: [
                    { required: true, message: '请选择推荐单位', trigger: 'change' }
                ],
                tjgr_id: [
                    { required: true, message: '请选择推荐个人', trigger: 'change' }
                ]
            }
        }
    },
    computed: {
        // 当前登录类型
        loginType() {
            const typeMap = {
                first: '成果申报',
                second: '推荐单位',
                third: '推荐个人',
                fourth: '专家评委'
            }
            return typeMap[this.activeName] || '成果申报'
        },
        // 动态获取 type 值
        typeValue() {
            switch (this.activeName) {
                case 'first': // 成果申报
                    return 1
                case 'second': // 推荐单位
                    return this.tjdwSelectIndex === 0 ? 2 : 3
                case 'third': // 推荐个人
                    return 4
                case 'fourth': // 专家评委
                    return 5
                default:
                    return 1
            }
        },
        ...mapState('userAbout', ['userInfo'])
    },
    mounted() {
        // 接收路由参数，设置 activeName
        if (this.$route.query.activeName) {
            this.activeName = this.$route.query.activeName
        }
        this.getRecommendListData();
        this.getRecommendListIndividualData()
        // 记住密码：自动填充
        this.loadRememberedPwd()
    },
    methods: {
            goHomeUrl(){
      window.open("https://www.isefc.org/index.php/zh/", "_blank");
    },
        getRecommendListIndividualData(){
            this.$API.getLoginRecommendList({
                identify:2,
            }).then(res => {
                this.IndividualList = res.data;
            })
        },
        getRecommendListData(){
            this.$API.getLoginRecommendList({
                identify:1,
            }).then(res => {
                this.recommendList = res.data;
            })
        },
        togglePwdType() {
            this.pwdType = this.pwdType === 'password' ? 'text' : 'password'
        },
        onSubmit() {
        
            this.$refs.loginForm.validate(async (valid) => {
                  
                if (valid) {
                      if(this.activeName =='first' || (this.activeName == 'second' && this.tjdwSelectIndex == 1)){
                if(!/^1[3-9]\d{9}$/.test(this.formLabelAlign.mobile)){
                    this.$message.error('请输入正确的手机号')
                    return
                }
            }
                    this.loading = true
                    // 去除 value 为空的 key
                    const loginData = Object.keys(this.formLabelAlign).reduce((obj, key) => {
                        if (this.formLabelAlign[key] !== '' && this.formLabelAlign[key] !== null && this.formLabelAlign[key] !== undefined) {
                            obj[key] = this.formLabelAlign[key]
                        }
                        return obj
                    }, {})
                    
                    // 处理 tjdw_id 和 tjgr_id，转换为 id
                    if (loginData.tjdw_id) {
                        loginData.id = loginData.tjdw_id
                        delete loginData.tjdw_id
                    } else if (loginData.tjgr_id) {
                        loginData.id = loginData.tjgr_id
                        delete loginData.tjgr_id
                    }
                    loginData.type = this.typeValue
                    // 调用 store 中的登录方法
                    try {
                        const res = await this.$store.dispatch('userAbout/userLogin', loginData)
                        console.log("res=========", res);
                        if (res === 'OK') {
                            this.$message.success('登录成功')
                            // 记住密码
                            if (this.rememberPwd) {
                                this.rememberPwdSave()
                            }
                            // 登录成功后根据用户类型跳转
                            const userType = this.userInfo?.type
                            if (userType === 1) {
                                this.$router.push('/bgManage/projectIntroduction')
                            } else if ([2, 3, 4].includes(userType)) {
                                this.$router.push('/bgManage/pendingPersonal')
                            } else if (userType === 5) {
                                this.$router.push('/bgManage/judge/arrangeList')
                            }
                        } else {
                            this.$message.error('登录失败')
                        }
                    } finally {
                        this.loading = false
                    }
                } else {
                    console.log('表单校验失败')
                    return false
                }
            })
        },
        goRegister() {
            // 跳转到注册页面，携带登录类型
            this.$router.push({ path: "/Register" });
        },
        // 记住密码：保存账号密码
        rememberPwdSave() {
            if (this.rememberPwd) {
                const data = {
                    mobile: this.formLabelAlign.mobile,
                    password: this.formLabelAlign.password,
                    type: this.activeName
                }
                localStorage.setItem('rememberPwdData', JSON.stringify(data))
            } else {
                localStorage.removeItem('rememberPwdData')
            }
        },
        // 记住密码：加载保存的账号密码
        loadRememberedPwd() {
            const savedData = localStorage.getItem('rememberPwdData')
            if (savedData) {
                try {
                    const data = JSON.parse(savedData)
                    // 只有在成果申报(tab first)时才自动填充
                    if (data.type === 'first') {
                        this.formLabelAlign.mobile = data.mobile || ''
                        this.formLabelAlign.password = data.password || ''
                        this.rememberPwd = true
                    }
                } catch (e) {
                    console.error('解析记住密码数据失败', e)
                }
            }
        },
        forgetPwd() {
            this.$router.push({ path: "/ForgotPassword" });
            // 跳转到忘记密码页面
            console.log('忘记密码类型:', this.loginType)
        },
        handleClick(tab, event) {
            console.log('切换到:', this.loginType)
            // 切换 tab 时清空校验状态
            this.$refs.loginForm.resetFields()
        }
    }
}
</script>
<style scoped>
.notActive{
    width: 189px;
height: 40px;
border-radius: 0px 0px 0px 0px;
border: 1px solid #E2E2E2;

font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #707070;
line-height: 21px;

}
.active{
    width: 189px;
height: 40px;
background: #2F86FF;
border-radius: 0px 0px 0px 0px;

font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #FFFFFF;
line-height: 21px;

}
.selectTab{
    display: flex;
    justify-content: center;
    cursor: pointer;
}
.tjdwImg{
    width: 15px;
    height: 15px;
    margin-right: 7px;
}
.loginBtn {
    width: 100%;
}

.registerBtn {
    width: 100%;
    margin-top: 15px;
}

::v-deep .el-button+.el-button {
    margin-left: 0 !important;
}

::v-deep .el-form-item {
    margin-bottom: 10px !important;
}

.pwdOptions {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.forgetPwd {
    color: #409EFF;
    cursor: pointer;
    font-size: 14px;
}

.forgetPwd:hover {
    text-decoration: underline;
}

.pwdDiv {
    position: relative;
}

.pwdImg {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    width: 18px;
    height: 15px;
}

.tabsDiv {
    margin-top: 20px;
}

::v-deep .el-form-item__label {
    padding: 0 !important;
}

::v-deep .el-tabs__item {
    font-size: 16px !important;
}

::v-deep .el-tabs__nav {
    padding-bottom: 6px;
}

.loginFormTitle {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 20px;
    color: #393939;
    text-align: center;
}

.loginFormContent {
    padding: 20px;
}

.loginFormDiv {
    display: flex;
    justify-content: center;
}

.loginForm {
    width: 459px;
    background: #F7F8FC;
    box-shadow: 0px 0px 8px 1px rgba(112, 112, 112, 0.1);
    border-radius: 12px 12px 12px 12px;
}

.copyrightText {
    margin: 0 20px;
}

.logoImg {
    width: 323px;
    height: 76px;
}

.login {
    width: 100%;
    min-height: 100vh;
    background: url('../../../assets/loginBg.png') no-repeat center center;
    background-size: 100% 100%;
}

.logoDiv {
    display: flex;
    justify-content: center;
    margin-top: 70px;
    margin-bottom: 20px;
}
.flexAliCenter{
    display: flex;
    align-items: center;
}
.pl10{
    padding-left: 20px;
}
</style>